const DASHBOARD_URL = 'https://demo.acelcortex.ai/';

export function shouldShowDemoDashboardLink(hostname = window.location.hostname): boolean {
  return (
    hostname === 'demo.acelcortex.ai' ||
    hostname === 'sandbox.acelcortex.ai' ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === ''
  );
}

export function DemoDashboardLink() {
  if (!shouldShowDemoDashboardLink()) return null;
  return (
    <a
      href={DASHBOARD_URL}
      className="btn-secondary"
      style={{ padding: '8px 14px', fontSize: 12, whiteSpace: 'nowrap' }}
    >
      ← Dashboard
    </a>
  );
}
